import React from "react";
import "./Footer.css";
import LogoImage from "images/logo blanc.png";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaTiktok, FaWhatsapp, FaYoutube } from 'react-icons/fa';
import { useTranslation } from "react-i18next";

const Footerr = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer" style={{ marginLeft: "-33px", marginRight: "-33px", marginBottom: "-50px" }}>
      <div className="footer-content">

        {/* Left Section */}
        <div className="footer-brand">
          <img src={LogoImage} alt="Rehab Bio Logo" className="footer-logo" />
          <p className="footer-description">  {t("footer.description")}</p>

          <h4 className="footer-subtitle">{t("footer.follow_us")}</h4>
         <div className="footer-socials">
  <a href="https://web.facebook.com/profile.php?id=61584737677221" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
  <a href="https://www.instagram.com/elancia_bio_/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
  <a href="https://api.whatsapp.com/send/?phone=212673496838&text=%D9%85%D8%B1%D8%AD%D8%A8%D8%A7%D9%8B%D8%8C+%D8%A3%D8%B1%D9%8A%D8%AF+%D8%A7%D9%84%D9%85%D8%B2%D9%8A%D8%AF+%D9%85%D9%86+%D8%A7%D9%84%D9%85%D8%B9%D9%84%D9%88%D9%85%D8%A7%D8%AA.&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
</div>

          {/* <h4 className="footer-subtitle">footer.newsletter")}</h4> */}
          {/* <p className="footer-note">footer.newsletter_note")}</p> */}
        </div>


<div className="footer-columns">
  <div className="footer-col">
    <h4>{t("footer.our_brand")}</h4>
<ul>
  <li>
    <Link to="/à-props">{t("footer.about")}</Link>
  </li>
  <li>
    <Link to="/blog">{t("footer.contact")}</Link>
  </li>
</ul>
  </div>

  <div className="footer-col">
    <h4>{t("footer.our_ranges")}</h4>
<ul>
  <li><Link to="/Boutique">{t("footer.range_hair_loss")}</Link></li>
  <li><Link to="/Boutique">{t("footer.range_weight_gain")}</Link></li>
  <li><Link to="/Boutique">{t("footer.range_slimming")}</Link></li>
  <li><Link to="/Boutique">{t("footer.range_anti_smoking")}</Link></li>
</ul>
</div>

  {/* <div className="footer-col">
    <h4>footer.customer_service</h4>
    <ul>
      <li><Link to="/contact">footer.faq</Link></li>
      <li><Link to="/contact">footer.contact_us</Link></li>
      <li><Link to="/contact">footer.refund_policy</Link></li>
      <li><Link to="/contact">footer.privacy_policy</Link></li>
      <li><Link to="/contact">footer.return_policy</Link></li>
      <li><Link to="/contact">footer.terms</Link></li>
    </ul>
  </div> */}

  <div className="footer-col">
   <h4>{t("footer.member_area")}</h4>
<Link to="/signup">
  <button className="footer-btn">{t("footer.signup")}</button>
</Link>
<Link to="/signup">
  <button className="footer-btn">{t("footer.login")}</button>
</Link>
  </div>
</div>

      </div>

      <div className="footer-bottom">
       <p>© {t("footer.brand")}</p>
<p>
  &copy; {t("footer.created_by")}{" "}
  <a href="https://agencywmg.com/" style={{ color: "#FFFFF" }}>
    agencywmg
  </a>. {t("footer.rights")}
</p>
      </div>
    </footer>
  );
};

export default Footerr;
